import { notification } from "antd";
import moment from "moment";
import toast from "react-hot-toast";

export const numberWithCommas = (money) => {
  return Number(money)
    .toLocaleString({
      style: "currency",
      currency: "KES",
    })
    ?.toLowerCase();
};

export function capitalize(s) {
  return s && s[0].toUpperCase() + s.slice(1);
}

export function cashConverter(money) {
  return capitalize(
    Number(money).toLocaleString("en-US", {
      style: "currency",
      currency: "KES",
    })
  );
}

export const formatMoney = (money) => {
  let keCurrency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "KES",
  });
  if (!money) {
    return "";
  }
  return keCurrency.format(money);
};

export const obfuscateEmail = (email) => {
  const [username, domain] = email?.split("@");

  if (!username || !domain) {
    throw new Error("Invalid email format");
  }
  const obfuscatedUsername = username?.substring(0, 2) + "****";
  return `${obfuscatedUsername}@${domain}`;
};

export const addSpaces = (number) => {
  const numberStr = number?.toString();
  const formattedStr = numberStr?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return formattedStr;
};

export const getFirstAndLastWords = (text) => {
  var text_arr = text?.split("");
  if (text_arr?.length) {
    return String(text_arr[0] + text_arr[text_arr.length - 1]).toUpperCase();
  }
  return "";
};

export const previewPaper = (doc) => {
  let link = formatImgPath(doc);
  if (
    getFileType(doc) == "docx" ||
    getFileType(doc) == "doc" ||
    getFileType(doc) == "pdf"
  ) {
    window.open(`${link}`, "_blank");
  } else {
    window.open(link, "_blank");
  }
};

const getFileType = (file) => {
  return file?.substring(file.lastIndexOf(".") + 1);
};
export const formatPath = (path) => {
  if (!path) return "";
  return path?.substring(path.lastIndexOf("/") + 1);
};

export const formatPathDoc = (path) => {
  if (!path) return "";
  const filename = path.substring(path.lastIndexOf("/") + 1);
  return filename.includes("_")
    ? filename.substring(filename.indexOf("_") + 1)
    : filename;
};

// export const formatImgPath = (path) => {
//   console.log("pathreceved",path)
//   if (!path || typeof path !== "string") {
//     return path;
//   }

//   const host = window.location.host;
//   const protocol = window.location.protocol;
//   const domain = "http://102.217.125.162/file";

//   if (path.startsWith("http") || path.startsWith("/")) {
//     return path;
//   }

//   return host.startsWith("localhost")
//     ? `${protocol}//${domain}/${path}`
//     : `https://${domain}/${path}`;
// };

export const formatImgPath = (path) => {
  if (!path || typeof path !== "string") {
    return "avatar.png";
  }

  const host = window.location.host;
  const protocol = window.location.protocol;
  const domain = "scheme.nisip.co.ke/file";

  if (path.startsWith("https") || path.startsWith("/")) {
    return path;
  }

  const filename = path.split("/").pop();

  return host.includes("localhost")
    ? `${protocol}//${domain}/${filename}`
    : `https://${domain}/${filename}`;
};

export const dateForHumans = (timestamp) => {
  if (!timestamp) return;
  let date = new Date(timestamp);

  let day = date.getDate();
  let month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(date);
  let year = date.getFullYear();

  let dayString = day + getDaySuffix(day);

  return `${dayString} ${month} ${year}`;
};

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

export const removeCommas = (numberString) => {
  if (
    typeof numberString !== "string" ||
    numberString === null ||
    numberString === undefined
  ) {
    return numberString;
  }

  return numberString.replace(/,/g, "");
};
export const removeNegative = (number) => {
  return Math.abs(number);
};

export const disabledDate = (current) => {
  return current && current > moment().startOf("day");
};

export const disabledPastDate = (current) => {
  return current && current < moment().startOf("day");
};

export const getFirstLetter = (word) => {
  if (!word || typeof word !== "string") return "Invalid input";

  return word.charAt(0);
};

export const getLetterWord = (sentence) => {
  if (!sentence || typeof sentence !== "string") return "Invalid input";
  const words = sentence?.split(" ");
  const firstLetters = words?.map((word) => word?.charAt(0));

  return firstLetters?.join("");
};

// export const getSubdomain = () => {
//   const hostname = window?.location?.hostname;

//   if (!hostname) return null;

//   const parts = hostname?.split('.');

//   if (parts?.length >= 3) {
//     return parts[parts?.length - 3];
//   }

//   return "localhost";
// };

export const getSubdomain = () => {
  const hostname = window?.location?.hostname;

  if (!hostname) return null;

  const parts = hostname.split(".");
  const commonTLDs = ["com", "co", "org", "net"];

  if (parts.length >= 2) {
    const tld = parts[parts.length - 1];

    if (commonTLDs.includes(tld)) {
      return parts[parts.length - 2];
    } else if (
      parts.length >= 3 &&
      commonTLDs.includes(parts[parts.length - 2])
    ) {
      return parts[parts.length - 3];
    }
  }

  return "localhost";
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1)?.padStart(2, "0");
  const day = String(date?.getDate())?.padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const getDate7DaysAgo = () => {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today?.getDate() - 7);
  const year = sevenDaysAgo?.getFullYear();
  const month = String(sevenDaysAgo?.getMonth() + 1)?.padStart(2, "0");
  const day = String(sevenDaysAgo?.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
export const getDate30DaysAgo = () => {
  const today = new Date();
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(today?.getDate() - 30);
  const year = thirtyDaysAgo?.getFullYear();
  const month = String(thirtyDaysAgo?.getMonth() + 1)?.padStart(2, "0");
  const day = String(thirtyDaysAgo?.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getDate90DaysAgo = () => {
  const today = new Date();
  const nityDaysAgo = new Date(today);
  nityDaysAgo.setDate(today?.getDate() - 90);
  const year = nityDaysAgo?.getFullYear();
  const month = String(nityDaysAgo?.getMonth() + 1)?.padStart(2, "0");
  const day = String(nityDaysAgo?.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getTomorrowDateMorning = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow?.setDate(tomorrow.getDate() + 1);

  const year = tomorrow?.getFullYear();
  const month = String(tomorrow?.getMonth() + 1)?.padStart(2, "0");
  const day = String(tomorrow?.getDate())?.padStart(2, "0");

  return `${year}-${month}-${day} 08:00`;
};

export const getTomorrowDateAfternoon = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow?.setDate(tomorrow.getDate() + 1);

  const year = tomorrow?.getFullYear();
  const month = String(tomorrow?.getMonth() + 1)?.padStart(2, "0");
  const day = String(tomorrow?.getDate())?.padStart(2, "0");

  return `${year}-${month}-${day} 1:00`;
};

export const getCurrentFormattedDate = () => {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const today = new Date();
  return today?.toLocaleDateString("en-US", options);
};

export const timeAmPmUtc = (utcTimestamp) => {
  if (!utcTimestamp) return;

  const utcDate = new Date(utcTimestamp);

  const eatTime = new Date(utcDate.getTime() + 3 * 60 * 60 * 1000);

  const time = eatTime.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return time;
};

export const getTimeOfDay = () => {
  var currentTime = new Date();
  var currentHour = currentTime?.getHours();

  if (currentHour < 12) {
    return "morning";
  } else if (currentHour < 18) {
    return "afternoon";
  } else {
    return "night";
  }
};
export const timeAmPm = (timestamp) => {
  if (!timestamp) return;

  let time = new Date(timestamp).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  return time;
};

export const timePart = (isoString) => {
  console.log("isoString", isoString);
  const timePart = new Date(isoString)
    ?.toISOString()
    ?.split("T")[1]
    ?.split(".")[0];
  return timePart;
};

export const formattedDate = (date) => {
  const formattedDate = date.toISOString().split("T")[0];
  return formattedDate;
};

export const normalizeDateToLocal = (date) => {
  if (!date) return null;
  const jsDate = new Date(date);
  const year = jsDate?.getFullYear();
  const month = String(jsDate?.getMonth() + 1)?.padStart(2, "0");
  const day = String(jsDate?.getDate())?.padStart(2, "0");
  return `${day}/${month}/${year}`;
};


export const normalizeDateToLocalYear = (date) => {
  if (!date) return null;
  const jsDate = new Date(date);
  const year = jsDate?.getFullYear();
  const month = String(jsDate?.getMonth() + 1)?.padStart(2, "0");
  const day = String(jsDate?.getDate())?.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const extractYear = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date?.getFullYear();
};

export const formatText = (str) => {
  if (typeof str !== "string") return "";
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const getInitials = (fullName) => {
  return fullName
    ?.split(" ")
    ?.map((word) => word?.charAt(0).toUpperCase())
    ?.join("");
};
const avatarColors = [
  "#f56a00",
  "#7265e6",
  "#ffbf00",
  "#00a2ae",
  "#87d068",
  "#1890ff",
  "#eb2f96",
];

export const getColorFromName = (name) => {
  let hash = 0;
  for (let i = 0; i < name?.length; i++) {
    hash = name?.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math?.abs(hash % avatarColors?.length);
  return avatarColors[index];
};

export const formatPipelineName = (str) => {
  const lastPart = str?.split("_")?.pop();
  return lastPart?.toLowerCase()?.replace(/^\w/, (c) => c?.toUpperCase());
};
